var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliticalDebateRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#F5F5F5;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F0F0F0;}\n\t.st5{fill:#F1AB1E;}\n\t.st6{opacity:0.2;enable-background:new    ;}\n\t.st7{fill:#263238;}\n\t.st8{fill:#FFB573;}\n\t.st9{fill:#E0E0E0;}\n\t.st10{fill:#ED893E;}\n\t.st11{fill:#FAFAFA;}\n\t.st12{fill:#FFC3BD;}\n\t.st13{opacity:0.4;enable-background:new    ;}\n\t.st14{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st15{fill:#ED847E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 389.9,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 398.4,
    className: "st0",
    width: 44,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 399.2,
    className: "st0",
    width: 44.8,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 389.7,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.8,
    y: 389.7,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 393.9,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,337.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7H237c3.2,0,5.7,2.6,5.7,5.7c0,0,0,0,0,0 v271.4C242.7,335.2,240.2,337.8,237,337.8z M43.9,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5 V60.7c0-3-2.4-5.5-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,337.8H260.2c-3.2,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.5,5.7,5.7v271.4 C459,335.2,456.5,337.8,453.3,337.8z M260.2,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5V60.7 c0-3-2.4-5.5-5.5-5.5H260.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 44,
    className: "st1",
    width: 380.1,
    height: 325.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 44,
    className: "st2",
    width: 384.1,
    height: 325.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.6,
    y: 54.9,
    className: "st3",
    width: 362.7,
    height: 303.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.8,
    y: 54.9,
    className: "st1",
    width: 4.5,
    height: 303.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.4,
    y: 297.6,
    className: "st2",
    width: 375.2,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.4,
    y: 74.2,
    className: "st2",
    width: 375.2,
    height: 14.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.1,28.7H31.8c0,71.5-3.3,271.8-3.3,271.8h23L50.1,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.2,28.7H61.8c0,69.1-3.8,262.7-3.8,262.7h26.8L83.2,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.2,28.7H93.8c0,69.1-3.8,262.7-3.8,262.7h26.8L115.2,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.6,28.7H44.2c0,77.5-3.9,294.7-3.9,294.7h26.8L65.6,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.8,28.7H80.4c0,77.5-3.9,294.7-3.9,294.7h26.8L101.8,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404.9,28.7h-18.3c0,71.5-3.3,271.8-3.3,271.8h23L404.9,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438,28.7h-21.3c0,69.1-3.9,262.7-3.9,262.7h26.8L438,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M470,28.7h-21.3c0,69.1-3.9,262.7-3.9,262.7h26.8L470,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,28.7H399c0,77.5-3.9,294.7-3.9,294.7h26.8L420.4,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.6,28.7h-21.4c0,77.5-3.9,294.7-3.9,294.7h26.8L456.6,28.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    className: "st2",
    cx: 250,
    cy: 416.2,
    rx: 193.9,
    ry: 11.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 61.3,
    transform: "matrix(0.1066 -0.9943 0.9943 0.1066 201.6004 357.7275)",
    className: "st5",
    width: 1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.3,95l-1-0.1l1.1-10.6c0.4-4-0.8-7.9-3.3-11c-0.9-1.1-2-2.2-3.2-3l0.6-0.8c1.3,0.9,2.4,2,3.4,3.2 c2.7,3.3,3.9,7.5,3.5,11.8L318.3,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M223.9,102.1l3-27.7c0.7-6.9,6.9-11.8,13.8-11.1l64.2,6.9c6.8,0.8,11.8,6.9,11.1,13.8l-3,27.7 c-0.7,6.9-6.9,11.8-13.8,11.1l-1.3-0.2c0.8,4.6,3.3,10.5,9.7,17.3c-13.2-4.7-20-12.1-23.5-18.8l-49.1-5.2 C228.1,115.2,223.2,109,223.9,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M273.4,86.1l-5.7-19.9l-27-2.9c-6.9-0.7-13,4.2-13.8,11.1l-3,27.7c-0.4,3.8,1,7.6,3.7,10.2l37.2-10.8 C271.4,99.7,275.2,92.8,273.4,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M270.1,85.8l-3.7-27.6c-0.9-6.8-7.2-11.6-14.1-10.7l-64,8.6c-6.9,0.9-11.7,7.2-10.8,14.1l3.7,27.6 c0.9,6.8,7.2,11.6,14.1,10.8l1.3-0.2c-0.6,4.6-3,10.6-9.2,17.6c13.1-5,19.7-12.6,23-19.4l49-6.6C266.2,98.9,271,92.6,270.1,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.5,127.2l1.5-1.7c5-5.6,8.1-11.2,9-16.6l-0.6,0.1c-7.1,0.9-13.7-4.1-14.7-11.2L177,70.2 c-0.9-7.1,4.1-13.7,11.2-14.7l64-8.6c7.1-1,13.7,4.1,14.7,11.2l3.7,27.6c1,7.1-4.1,13.7-11.2,14.7l-48.7,6.5 c-4.3,8.6-12.1,15.2-23.1,19.4L185.5,127.2z M197.2,107.7l-0.1,0.7c-0.8,5.3-3.4,10.7-7.9,16.1c9.8-4.2,16.8-10.3,20.6-18.3 l0.1-0.3l49.3-6.6c6.6-0.9,11.2-6.9,10.3-13.5l-3.7-27.6c-0.9-6.6-6.9-11.2-13.5-10.3l-64,8.6c-6.6,0.9-11.2,6.9-10.4,13.4 c0,0,0,0,0,0l3.7,27.6c0.9,6.6,6.9,11.2,13.5,10.3L197.2,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.2,79.3c0.6,3.6-1.8,7-5.4,7.6s-7-1.8-7.6-5.4s1.8-7,5.4-7.6c0,0,0,0,0,0 C205.2,73.3,208.6,75.7,209.2,79.3C209.2,79.3,209.2,79.3,209.2,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.6,80c0.6,3.6-1.8,7-5.4,7.6s-7-1.8-7.6-5.4c-0.6-3.6,1.8-7,5.4-7.6c0,0,0,0,0,0 C225.6,74,229,76.4,229.6,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248,68.8c0.6,3.6-1.8,7-5.4,7.6s-7-1.8-7.6-5.4s1.8-7,5.4-7.6c0,0,0,0,0,0C244,62.8,247.4,65.2,248,68.8 C248,68.8,248,68.8,248,68.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174,169.7l2.5,2.9l2.6,3c1.7,1.9,3.5,3.9,5.2,5.7c0.9,0.9,1.8,1.8,2.7,2.6s1.8,1.6,2.6,2.4s1.8,1.4,2.5,1.9 c0.6,0.4,1.2,0.8,1.9,1.1l-1.5-0.2c-0.4-0.1-0.9,0-1.2,0.3c0,0.1,0.2,0,0.6-0.2c0.9-0.5,1.7-1.1,2.4-1.9c1.9-1.8,3.8-3.8,5.4-5.9 c1.8-2.2,3.6-4.5,5.3-6.8l5.2-7.1l0.1-0.1c1.4-1.9,4.1-2.3,6-0.9c1.5,1.1,2.1,3,1.5,4.7c-1,3-2.1,5.9-3.3,8.8 c-1.2,2.9-2.6,5.7-4.2,8.5c-1.6,3-3.5,5.8-5.6,8.4c-1.3,1.6-2.7,3-4.2,4.2c-1,0.8-2.1,1.5-3.4,2.1c-1.8,0.8-3.7,1.2-5.6,1.2 c-0.3,0-0.7-0.1-1-0.1l-0.4-0.1c-2-0.5-3.9-1.2-5.8-2.1c-1.5-0.8-3-1.7-4.5-2.7c-2.6-1.8-5.1-3.7-7.4-5.9c-2.3-2-4.3-4.2-6.3-6.4 c-1-1.1-2-2.2-2.9-3.4c-0.5-0.6-0.9-1.1-1.4-1.7l-1.4-1.9c-2.8-3.8-2.1-9.1,1.7-11.9c3.6-2.7,8.6-2.2,11.6,1.2L174,169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.6,165.4c0.5-4.2,8.2-6.1,8.2-6.1l4.5-2c1.5-0.7,3.3-0.2,4.2,1.2l2.3,3.5c1,1.6,0.6,3.6-0.9,4.7 c0,0,0,0-0.1,0l-4.1,2.6c-0.7,0.5-1.5,0.7-2.4,0.9l-3.5,0.4c-3,0.4-5.9-1-7.5-3.5l-0.2-0.3C210.7,166.4,210.6,165.9,210.6,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126.1,164c11.8-1.5,28.7-1.3,40,0.6c5.8,1.1,10.3,5.7,11.1,11.5c2.4,17.1,0.3,47-1.2,77 c-25.8,8.9-53.1-0.1-53.1-0.1c-0.9-6.1,1.2-25.9,2.6-36.6c-2.1-11-6.7-23.5-9.6-38.1c-1.4-6.4,2.6-12.8,9-14.2 C125.2,164.1,125.6,164,126.1,164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.5,163.5c1.6,1.9,2.6,4.1,2.9,6.6c1.2,6.9-0.2,17.6-3.8,29.9c-3.5-9.9-11-23-15.7-30.6 c-2.2-3.6-3.7-6-3.9-6.2l0,0C142.8,161.6,149.8,161.7,156.5,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.2,144.2c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2C141.3,139.9,143.2,141.8,143.2,144.2 C143.2,144.2,143.2,144.2,143.2,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.3,128.5c-0.2,3.9-2.7,6.9-5.5,6.8s-5-3.4-4.8-7.3s2.7-7,5.5-6.8S165.5,124.6,165.3,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M138.2,140.2l14.6,11.9c-1.9,5-0.5,10,3.8,11.4c0.7,2.2-1.8,4.5-4.2,6.7c-5.5-0.7-12.1-1.7-15.4-6.3 C138,160.2,139.6,147.6,138.2,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.1,167.7c-0.6,1.6-1.5,3.1-2.8,4.2c-2.1,0-5.1-2.3-5.1-2.3s1.2-3.3,2.8-3.9 C154.2,166.7,155.1,167.7,155.1,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M150.4,170.5c0.6-0.5,1.5-0.7,2.3-0.6c2.7,3.8,4.4,9.8,6.1,16.6c-0.8,4.5-1.9,9-3.2,13.4 c-1.5-4.1-3.2-8-5.2-11.9C151.1,182.2,151.1,176.3,150.4,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M152.8,152.1l-8.6-7c-0.4,1.5-0.6,3.1-0.5,4.7c0.2,3.2,4.6,6.7,8.3,7.2C151.9,155.4,152.1,153.7,152.8,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M135.6,131.3c1.4,9.7,1.8,15.5,7.1,20c8,6.9,19.7,1.3,21.2-8.7c1.4-9-1.2-23.3-11-26.3 c-7.1-2.2-14.7,1.8-16.9,8.9C135.4,127.2,135.3,129.3,135.6,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.4,131.6c-1.2-0.6-2.6-0.7-3.9-0.2C145.8,131.7,147.1,131.8,148.4,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.2,132.6c-1.2-0.3-2.4-0.1-3.4,0.7C146,133.3,147.2,133,148.2,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.5,138.2c-1-0.1-2,0.1-1.9,1.9C145,139.2,145.7,138.5,146.5,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M137.8,138.2c5.4-1.6,5.8-8.6,3.6-9.9c4.5,0.8,9.2-5.3,7.4-7.4c11,6,19,2.8,15.5-5.8c-4.1-10.1-16.5-6-16-3.5 c-6.8-4-18.3,0.9-13.4,5.7c-6.7-2.1-11.8,4.6-7.7,9.7c-8.6,4.5-0.3,14.6,3.1,13.8C129.8,144,138.6,147.6,137.8,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M158.1,142.9c0,0-2.9-1.3-11.4-3c0.6,2.5,2.1,4.8,6.5,5.7S158.1,142.9,158.1,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.4,143.3c1.7,0.3,3.3,1,4.6,2.1c-0.9,0.3-1.9,0.4-2.8,0.1c-1.7-0.3-3.3-1-4.5-2.1 C149.5,143.1,150.5,143.1,151.4,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.7,142.8c-0.3,0.6-0.9,0.9-1.5,0.9c-2.5-0.5-5-1.2-7.4-2.1c-0.8-0.2-1.4-0.8-1.7-1.5 C150.6,140.6,154.2,141.6,157.7,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.6,137.9c0.6,2.2,2,4,3.9,5.2c2.6,1.5,4.6-0.6,4.6-3.5c-0.1-2.5-1.5-6.4-4.4-6.7S131,135.2,131.6,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M150.9,131.7c0.1,0.8,0.5,1.4,1.1,1.4s0.9-0.7,0.8-1.5s-0.5-1.4-1.1-1.4S150.9,130.9,150.9,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M159.9,131.4c0.1,0.8,0.5,1.4,1.1,1.4s0.9-0.7,0.8-1.5s-0.5-1.4-1.1-1.4S159.9,130.6,159.9,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.7,132.5c0,0,2.2,4.4,4.4,6.4c-1.3,1.4-3.7,1.1-3.7,1.1L157.7,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.3,129.6c0.1,0.1,0.1,0.1,0.1,0.2c0,0.3-0.1,0.5-0.4,0.6c-1.5,0.4-3,0-4.2-1c-0.2-0.2-0.2-0.5,0-0.6 c0,0,0,0,0,0c0.2-0.2,0.5-0.2,0.7,0c0,0,0,0,0,0l0,0c0.9,0.8,2.1,1.1,3.3,0.8C153.1,129.5,153.2,129.5,153.3,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.1,127.8c-0.1,0.1-0.3,0-0.4-0.1c-0.9-0.7-2.2-1-3.3-0.7c-0.2,0.1-0.5,0-0.6-0.3c-0.1-0.2,0-0.5,0.3-0.6 c1.4-0.4,3-0.2,4.2,0.8c0.2,0.2,0.2,0.5,0.1,0.7c0,0,0,0,0,0C164.3,127.7,164.2,127.8,164.1,127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M136,163.2L136,163.2c0.1,0.2,1.7,2.6,3.9,6.2c2.2,2,4.9,3.5,7.9,4.1c-0.4-1.4,0.9-6.4,2.3-7.9 C146.6,165.8,142,165.3,136,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M150.1,165.7c3.1,1.4,5.6,4,6.8,7.2c1.2-0.5,2.1-1.5,2.6-2.8c-0.3-2.4-1.3-4.7-2.9-6.6 C155.7,164.5,153.6,165.5,150.1,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M130.7,180.4l-2.2,3.8l-2.3,3.9c-1.5,2.6-2.9,5.2-4.3,7.8s-2.6,5.2-3.6,7.6c-0.5,1.2-0.9,2.4-1.2,3.5 c-0.2,0.8-0.4,1.5-0.5,2.3c0.2,2,0.8,3.9,1.8,5.6c1.3,2.4,2.8,4.7,4.5,6.9c3.6,4.7,7.5,9.2,11.7,13.5l0.1,0.1 c1.6,1.7,1.5,4.4-0.2,6c-1.3,1.3-3.3,1.5-5,0.6c-2.9-1.6-5.7-3.4-8.4-5.3c-2.7-2-5.3-4.1-7.8-6.4c-2.6-2.4-5-5.1-7.1-7.9 c-1.1-1.6-2.1-3.3-3-5.1c-1-2.1-1.7-4.4-2-6.7c-0.2-2.3-0.1-4.7,0.3-7c0.3-1.9,0.8-3.7,1.4-5.5c1-3.3,2.3-6.5,3.8-9.7 c1.4-3.1,2.9-6,4.5-8.9c0.8-1.4,1.6-2.9,2.5-4.2s1.7-2.7,2.7-4.2c2.6-3.9,7.8-5.1,11.8-2.5c3.9,2.5,5,7.7,2.6,11.6L130.7,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.9,169.1c0-1.6,0.2-3.2,0.6-4.7c2.6-0.7,9.5,4.2,10.6,6.4c-0.4,1.3-3.4,4-3.4,4 C214.5,172.9,210.6,170.6,208.9,169.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "213.9,254.4 91.3,254.4 91.3,246.1 213.9,236.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.6,416.2 109.6,416.2 99.6,254.4 205.6,254.4  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.692884e-02 1.692884e-02 0.9999 -5.6156 2.6306)",
    className: "st3",
    cx: 152.6,
    cy: 333,
    rx: 26.3,
    ry: 26.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "204.8,266.7 99.8,257.9 99.6,254.4 205.6,254.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M126.7,237.1c0-0.5,0.1-0.9,0.3-1.3l2.3-3.3c0.4-0.7,1.2-1,2-0.9l3.4,0.5c3.3,0.5,6.4,1.7,9.2,3.5l0.9,0.6 c1.6,1,2,3.1,1,4.7c0,0,0,0,0,0.1l-2.4,3.4c-0.9,1.4-2.7,1.8-4.2,1.1l-4.4-2.1C134.7,243.4,127.1,241.3,126.7,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.5,230c1.6,0.1,3.2,0.3,4.6,0.9c0.5,2.6-4.7,9.3-7,10.2c-1.3-0.5-3.9-3.6-3.9-3.6 C126.4,235.4,129,231.6,130.5,230z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M205,234.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0-0.2,0.1-0.2c0.3-0.5,7.2-12.3-5.3-20.2c-0.2-0.1-0.3-0.5-0.2-0.7 c0.1-0.2,0.5-0.3,0.7-0.2c13.3,8.4,5.7,21.5,5.6,21.6C205.3,234,205.2,234.1,205,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M196,237.6l16.7-1.4c0,0-2-3.4-8.6-2.7S196,237.6,196,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.3,213.1L200.3,213.1c-0.5,0.7-1.4,0.8-2.1,0.4l-2.4-1.7c-0.7-0.5-0.8-1.4-0.4-2.1l0,0 c0.5-0.7,1.4-0.8,2.1-0.4l2.4,1.7C200.6,211.5,200.8,212.4,200.3,213.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.2,127.2c-11.6,5.9-16.6,14.4-14.1,22.4s-3,9.2-2.3,19.8s6.8,12.2,3.3,17.2s3.6,22.2,23.1,13.1 s27.8-25.4,22.8-34.9s-10-12.7-10-25C361,129.2,352.3,120,338.2,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.3,195.5l0.9,1.6c0.7,1.2,2,2.1,3.4,2.3l7.9,1.2l3.2-2.6c-1.9-3.7-7.2-6.7-7.2-6.7l-1.4-1 c-1.2-0.9-2.8-0.8-4,0.1l-2.4,2.2C280.9,193.3,280.7,194.5,281.3,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M333.1,188.9c-1,2.4-2.2,4.5-3.3,6.8s-2.4,4.3-3.7,6.4s-2.7,4.2-4.2,6.2s-3.1,4-4.7,5.9l-0.2,0.2 c-0.3,0.4-0.7,0.7-1.2,1c-1,0.6-2.1,0.9-3.3,1.1c-1,0.1-2,0.1-3-0.1c-1.6-0.3-3.1-0.8-4.4-1.6c-2.2-1.3-4.2-2.8-6-4.6 c-1.6-1.6-3.2-3.3-4.6-5.2c-1.4-1.8-2.7-3.7-3.9-5.6c-0.8-1.3-0.4-3,0.9-3.8c1-0.6,2.4-0.5,3.3,0.3l0.1,0.1 c1.5,1.4,3.1,2.8,4.7,4.1s3.2,2.6,4.8,3.7c1.5,1.1,3,2,4.7,2.6c0.5,0.2,1.1,0.4,1.7,0.4c0.4,0,0.2-0.1,0-0.1l-1.4,1.1 c2.6-3.7,5.1-7.6,7.3-11.5c1.1-2,2.2-4,3.3-6.1s2.1-4.1,3.1-6.1l0-0.1c1.3-2.8,4.6-4,7.3-2.7C333.2,182.8,334.4,186.1,333.1,188.9 L333.1,188.9L333.1,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M338,174.3c-14.8-2.8-26,23.5-26.4,29.4c0.5,5.4,10,5.7,10,5.7S342.1,193.3,338,174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M323.3,209.1c-0.6,0.7-1.3,1.3-2,1.8c-0.1,0-0.1,0.1-0.2,0.1c-0.9,0.1-7,0.4-10.6-4.2 c-0.1-0.1-0.1-0.2-0.1-0.3c-0.1-1.3,0.1-2.6,0.6-3.9c0.1-0.2,0.4-0.4,0.6-0.3c0,0,0.1,0,0.1,0.1c1.5,1.2,6.4,4.7,11.3,5.9 c0.3,0,0.4,0.3,0.4,0.5C323.4,209,323.4,209,323.3,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M374,252.3c0,0-7.2-15.2-7.4-25c-6.3,0-42.4-1.5-43.3,6.6c0.1,0.5-0.6,11.6-1.6,13.5 C327.9,259.3,354,256.6,374,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M374,252.3c0,0-7.2-15.2-7.4-25c-6.3,0-42.4-1.5-43.3,6.6c0.1,0.5-0.6,11.6-1.6,13.5 C327.9,259.3,354,256.6,374,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.9,189.4c-0.1,6,0.2,12,0.7,18c0.8,13.1,0.3,23,1.2,28.1c3.3,1.6,6.9,2.6,10.5,2.9 c0.7-1.2,1.5-2.4,2.4-3.4c0.9,0.7,3.8,2.8,5.5,3.1c7.8-0.6,22.6-2.8,26.4-6.3c-1.8-11-4-20.8,2.4-46c1.4-4.9-1.4-10-6.3-11.4 c-0.6-0.2-1.2-0.3-1.9-0.3c-1.6-0.1-3.2-0.2-4.9-0.2c-6-0.3-12-0.1-17.9,0.5c-1.9,0.2-4,0.5-5.9,0.8 C326.3,176.3,321.1,182.3,320.9,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M362.5,189.3c0.5,5.8,1.8,11.5,3.7,17c0.3-3.3,0.9-6.9,1.7-11.1L362.5,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M357.1,239.9l0.9-1.6c0.7-1.3,1.9-2.1,3.3-2.4l7.8-1.6l3.3,2.4c-1.7,3.8-6.9,7-6.9,7l-1.4,1 c-1.2,0.9-2.8,0.9-4,0l-2.5-2.1C356.8,242,356.6,240.9,357.1,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M373.8,185.2c0.5,0.6,0.8,1.1,1.2,1.6s0.7,1.1,1.1,1.6c0.7,1.1,1.4,2.2,2,3.3c1.3,2.2,2.5,4.5,3.6,6.8 c1.1,2.3,2.1,4.7,2.9,7.2c0.9,2.5,1.5,5.1,2.1,7.7l0,0.2v0.1v0.2c0.1,0.3,0.1,0.7,0.1,1c0,0.5,0,1.1,0,1.6 c-0.1,0.9-0.3,1.8-0.5,2.7c-0.5,1.5-1.1,2.8-1.9,4.2c-1.3,2.3-2.9,4.5-4.6,6.5c-3.3,3.8-6.9,7.3-10.8,10.5c-1.2,1-2.9,0.8-3.9-0.4 c-0.8-1-0.8-2.4-0.1-3.4l0.1-0.1c2.8-3.7,5.6-7.6,8-11.5c1.2-1.8,2.2-3.8,3.1-5.8c0.4-0.8,0.6-1.7,0.8-2.5c0.1-0.3,0.1-0.6,0.1-0.9 c0-0.1,0-0.2,0-0.2s0,0,0,0.1s0,0,0,0v-0.1l-0.1-0.2c-0.6-2.1-1.4-4.1-2.2-6.1c-0.9-2.1-1.8-4.1-2.8-6.1s-2.1-4-3.3-5.9 c-0.6-1-1.2-1.9-1.8-2.9l-0.9-1.4l-0.9-1.3l-0.1-0.2c-1.8-2.5-1.2-5.9,1.3-7.7S372.1,182.8,373.8,185.2L373.8,185.2L373.8,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.2,173.9c15-1.6,23.9,25.6,23.9,31.6c-1,5.3-10.5,4.8-10.5,4.8S355.6,192.5,361.2,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.3,186.5c-0.3,0-0.5-0.2-0.6-0.4s0.2-0.5,0.4-0.6c3.9-1.5,7.5-3.7,10.5-6.5c0.2-0.2,0.5-0.2,0.7,0 c0,0,0,0,0,0c0.2,0.2,0.2,0.5,0,0.7c0,0,0,0,0,0c-3.2,3-6.9,5.3-11,6.8L338.3,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M336.8,185.7c-0.1,0-0.3-0.1-0.4-0.2c-1.2-1.3-2.6-5.5-0.9-9.8c0.1-0.3,0.4-0.4,0.6-0.3s0.4,0.4,0.3,0.6l0,0 c-1.2,2.9-1,6.1,0.7,8.8c0.2,0.2,0.2,0.5,0,0.7C337,185.7,336.9,185.7,336.8,185.7L336.8,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M353.9,153.5c-0.9,5.9-1.7,16.5,2.1,20.2c0,0-5.5-0.7-16.9,6.8c-3.5-4.7-1-6.3-1-6.3 c6.5-1.7,6.5-5.7,5.2-10.1L353.9,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.5,179.1c3.8,0.4,5.2,6.2,5.2,6.2s9-6.7,11.8-11.4c-1.2-0.6-2.3-1.3-3.4-2 C355.1,171.9,343.7,176.8,341.5,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M337.9,178.5c0,0-3.3,1-4.4,5.6c-1.1-8.4,2.8-9.9,2.8-9.9c1-0.6,2.3-0.8,3.4-0.6 C338.1,174.6,337.3,176.7,337.9,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M349.6,157.9l-6.3,6.3c0.3,1,0.5,2.1,0.7,3.1c2.4-0.6,5.7-3.7,5.9-6.3C349.9,159.9,349.8,158.9,349.6,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M357.5,141.5c-0.7,9.4-0.8,13.4-5.6,18.4c-7.2,7.6-18.5,5.2-20.6-4.1c-1.9-8.4-0.4-22.4,8.8-26.5 c6-2.9,13.3-0.5,16.2,5.5C357.3,137,357.7,139.2,357.5,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M350.7,131.2c-7,8.2,8.1,14.5,9.1,23.9C361.1,144,358.5,124.9,350.7,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.2,131.8c-9.7,2.6-12.5,1.6-14.7,1.3c-2.3,2.5-17,8.4-14.6,0.4c1.1-3.7,7.4-12.8,19-12.7 S364.8,129.3,355.2,131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M351.6,132.9L351.6,132.9c-0.2,0-0.3-0.2-0.2-0.3c0,0,0,0,0,0c0.5-1.8-0.1-3.7-1.8-5.3 c-2.8-2.8-8.5-4.6-14-2.9c-0.1,0-0.3,0-0.3-0.1c0,0,0,0,0,0c0-0.1,0-0.3,0.1-0.3c0,0,0,0,0,0c5.6-1.8,11.5,0.1,14.5,3 c1.8,1.8,2.5,3.8,1.9,5.8C351.8,132.8,351.7,132.9,351.6,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M355.7,131.7L355.7,131.7c-0.1,0-0.2-0.1-0.2-0.3c0.4-2.6-1.7-5.2-5.3-6.5c-0.1,0-0.2-0.2-0.2-0.3 c0-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0c3.9,1.4,6.1,4.2,5.6,7.1C356,131.6,355.8,131.7,355.7,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M343,144.7c0,0.8-0.5,1.5-1,1.5s-0.9-0.6-0.9-1.4s0.5-1.4,1-1.5S343,143.9,343,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333.5,145.1c0,0.8-0.5,1.5-1,1.5s-0.9-0.6-0.9-1.4s0.5-1.4,1-1.5S333.5,144.4,333.5,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.9,143.8l-1.9-0.5C331,143.3,331.9,144.8,332.9,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M336.1,146.4c-0.7,1.8-1.7,3.6-2.9,5.2c0.8,0.6,1.8,0.8,2.8,0.5L336.1,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M340.1,154.5c-0.4,0-0.9,0-1.3-0.1c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.2,0.3-0.2 c2,0.3,4-0.4,5.4-1.8c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C343.4,153.7,341.8,154.4,340.1,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M359.2,151.2c-0.9,1.6-2.4,2.8-4.2,3.2c-2.2,0.4-3-2.1-2.1-4.5c0.8-2.2,2.9-5.1,5-4.4 S360.4,149.1,359.2,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344,139.6c-0.1,0-0.2-0.1-0.3-0.2c-0.7-0.9-1.8-1.4-2.9-1.4c-0.2,0-0.5-0.1-0.5-0.4c0,0,0,0,0,0 c0-0.3,0.2-0.5,0.4-0.5c1.4-0.1,2.8,0.5,3.7,1.7c0.1,0.2,0.1,0.5-0.1,0.6C344.2,139.6,344.1,139.7,344,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M330.7,141c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.6c0,0,0,0,0,0c0.9-1.2,2.4-1.9,3.9-1.8 c0.2,0,0.4,0.2,0.4,0.5c0,0,0,0,0,0c0,0.3-0.3,0.4-0.5,0.4c-1.2,0-2.3,0.5-3.1,1.5C331,140.9,330.9,141,330.7,141z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M342.4,143.3l-1.8-0.5C340.5,142.8,341.5,144.3,342.4,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.6,182.5c0.7,0.1,1.4,0.2,2.1,0.5c0.4,0.1,0.6,0.5,0.6,0.8c0,0.8-0.1,2.4,0,3.1c0,1.1-3.3,2.1-3.3,2.1 s-1.9-1.8-1.5-3.2c0.3-1,0.7-2,1.2-2.9C336.9,182.6,337.3,182.4,337.6,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M338.2,215c-1.3-9.6-0.4-28,0.8-27.7c-0.7-0.2-1.5-0.4-2.2-0.6c-2.2,2.2-5.8,14.5-6.6,28.2 c0.9,4.3,2.9,8.3,5.8,11.6C335.9,226.4,337.2,220.1,338.2,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M373,209.9c0.5,0.7,1.1,1.4,1.8,1.9c0.1,0,0.1,0.1,0.2,0.1c0.9,0.1,7,1,10.9-3.3c0.1-0.1,0.1-0.2,0.1-0.2 c0.2-1.3,0.1-2.6-0.3-3.9c-0.1-0.2-0.3-0.4-0.5-0.4c-0.1,0-0.1,0-0.2,0.1c-1.6,1-6.8,4.1-11.8,4.9c-0.3,0-0.4,0.3-0.4,0.5 C372.9,209.8,373,209.8,373,209.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "286.1,254.4 408.7,254.4 408.7,246.1 286.1,236.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "304.4,416.2 390.4,416.2 400.4,254.4 294.4,254.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 347.4,
    cy: 333,
    r: 26.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "295.2,266.7 400.2,257.9 400.4,254.4 294.4,254.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M295,234.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-7.7-13.2,5.6-21.6c0.2-0.1,0.5-0.1,0.7,0.1c0,0,0,0,0,0 c0.1,0.2,0.1,0.5-0.1,0.7c-12.5,7.9-5.6,19.7-5.3,20.2c0.1,0.2,0.1,0.6-0.2,0.7C295.2,234,295.1,234.1,295,234.1L295,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304,237.6l-16.7-1.4c0,0,2-3.4,8.6-2.7S304,237.6,304,237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.7,213.1L299.7,213.1c0.5,0.7,1.4,0.8,2.1,0.4l2.4-1.7c0.7-0.5,0.8-1.4,0.4-2.1l0,0 c-0.5-0.7-1.4-0.8-2.1-0.4l-2.4,1.7C299.4,211.5,299.2,212.4,299.7,213.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticalDebateRafiki);
export default __webpack_public_path__ + "static/media/Political-debate-rafiki.6ab0d289d05d6db4fb3616bc48628014.svg";
export { ForwardRef as ReactComponent };